interface ConsentPayload {
  accepted: boolean;
  acceptedCategories: string[];
  rejectedCategories: string[];
}

export async function logConsentToApi(apiUrl: string, data: ConsentPayload): Promise<void> {
  try {
    const payload = {
      visitorId: getVisitorId(),
      accepted: data.accepted,
      acceptedCategories: data.acceptedCategories,
      rejectedCategories: data.rejectedCategories,
      url: window.location.href,
      referrer: document.referrer,
      language: navigator.language,
    };

    const body = JSON.stringify(payload);

    // Prefer sendBeacon: survives tab close, no CORS preflight, fire-and-forget.
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      try {
        const blob = new Blob([body], { type: 'text/plain' });
        const queued = navigator.sendBeacon(apiUrl, blob);
        if (queued) return;
      } catch {
        // fall through to fetch fallback
      }
    }

    // Fallback: fetch with keepalive so the request still completes after unload.
    await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body,
      keepalive: true,
    }).catch(() => {
      console.warn('[Galletas4all] Could not reach logging API');
    });
  } catch {
    console.warn('[Galletas4all] Could not reach logging API');
  }
}

function getVisitorId(): string {
  let vid: string | null = null;
  try {
    vid = localStorage.getItem('galletas4all_vid');
  } catch {
    // Storage blocked (Safari ITP, quota); fall through to per-call ephemeral ID.
  }
  if (vid) return vid;

  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    vid = 'vid_' + crypto.randomUUID();
  } else {
    const arr = new Uint8Array(16);
    crypto.getRandomValues(arr);
    vid = 'vid_' + Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
  }

  try {
    localStorage.setItem('galletas4all_vid', vid);
  } catch {
    // ignore — vid still returned for this call
  }
  return vid;
}
